/**
 * Builds a filters payload object from filter state, only including non-null/empty values
 * @param {Object} filters - Filter state object
 * @returns {Object} Filters payload for API request
 */
export function buildFiltersPayload(filters) {
  const filtersPayload = {};

  if (filters.gender) {
    filtersPayload.gender = filters.gender;
  }

  if (filters.dominantHand) {
    filtersPayload.dominantHand = filters.dominantHand;
  }

  if (filters.secondarySubType) {
    filtersPayload.secondarySubType = filters.secondarySubType;
  }

  // Date range
  if (filters.userCreated?.from || filters.userCreated?.to) {
    filtersPayload.userCreated = {};
    if (filters.userCreated.from) {
      filtersPayload.userCreated.from = filters.userCreated.from;
    }
    if (filters.userCreated.to) {
      filtersPayload.userCreated.to = filters.userCreated.to;
    }
  }

  // Student credits range
  if (
    filters.studentCredits?.min != null ||
    filters.studentCredits?.max != null
  ) {
    filtersPayload.studentCredits = {};
    if (filters.studentCredits.min != null) {
      filtersPayload.studentCredits.min = filters.studentCredits.min;
    }
    if (filters.studentCredits.max != null) {
      filtersPayload.studentCredits.max = filters.studentCredits.max;
    }
  }

  // Report credits range
  if (
    filters.reportCredits?.min != null ||
    filters.reportCredits?.max != null
  ) {
    filtersPayload.reportCredits = {};
    if (filters.reportCredits.min != null) {
      filtersPayload.reportCredits.min = filters.reportCredits.min;
    }
    if (filters.reportCredits.max != null) {
      filtersPayload.reportCredits.max = filters.reportCredits.max;
    }
  }

  return filtersPayload;
}
